import { api } from "./client";

export type ExportJob = {
  id: number;
  project: number;
  preset: "720p" | "1080p" | "4k";
  use_originals: boolean;
  status: "queued" | "running" | "done" | "failed";
  progress: number;
  output_url: string | null;
  error_message: string;
  created_at: string;
  finished_at: string | null;
};

export async function startExport(
  projectId: number,
  preset: ExportJob["preset"] = "1080p",
  use_originals = true,
): Promise<ExportJob> {
  const r = await api.post("/exports/start/", { project_id: projectId, preset, use_originals });
  return r.data;
}

export async function listExports(projectId: number): Promise<ExportJob[]> {
  const r = await api.get(`/exports/jobs/?project=${projectId}`);
  return r.data.results || r.data;
}

export async function getExport(id: number): Promise<ExportJob> {
  const r = await api.get(`/exports/jobs/${id}/`);
  return r.data;
}
